import React, { useEffect, useState } from 'react';
import { pageTitle } from '../PageTitle';
import BreadCrumb from '../BreadCrumb';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import { Link } from 'react-router-dom';
import two from "../../assets/images/resource/choose-05.png";
import { fetchServices } from '../../DataFetchers/fetchServices';


const Services = () => {
    pageTitle('Services');
    const [servicesData, setServicesData] = useState([])

    useEffect(() => {
        fetchServices().then((data) => {
            setServicesData(data);
        });
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });



    const handleSubmit = async (e) => {
        e.preventDefault();

        // Get form data
        const formDataObj = new FormData(e.target);
        const formObject = {
            name: formDataObj.get('name'),
            email: formDataObj.get('email'),
            subject: formDataObj.get('subject'),
            phone: formDataObj.get('phone'),
            message: formDataObj.get('message')
        };

        // Log the form data
        console.log('Contact Form Submission:', formObject);

        try {
            // Send data to API endpoint
            const response = await fetch('https://simsolver.epitomeri.com/api/user/epitomeri_contact_form_submission', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formObject)
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Form submitted successfully:', result);
                alert('Message sent successfully!');
                e.target.reset(); // Clear the form
                // Clear the form state as well
                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    phone: '',
                    message: ''
                });
            } else {
                console.error('Form submission failed:', response.statusText);
                alert('Failed to send message. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    return (

        <>
            <HeaderOne></HeaderOne>
            <BreadCrumb></BreadCrumb>
            <div className="service__page p_relative see__pad">
                <div className="auto-container">
                    <div className="row">
                        {servicesData.map((item, id) => (
                            <div className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms" key={id} style={{ marginBottom: "4vh" }}>
                                <div className="service__block h-100">
                                    <div className="service__icon">
                                        <i className={item.icon}></i>
                                        <div className="service__icon__two"></div>
                                    </div>
                                    <div className="service__text">
                                        <h4><Link to={item.href} state={{ service: item, services: servicesData }} >{item.title}</Link></h4>
                                        {/* <p>{item.description}</p> */}
                                    </div>
                                    <div className="service__button">
                                        <Link to={item.href} state={{ service: item, services: servicesData }} ><i className="icon-05"></i></Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* <section className="service__two p_relative">
            <div className="row">
                {servicesData.map((item, id)=>(
                    <div className="col-xl-3 col-lg-6 col-md-12 wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms" key={id}>
                        <div className="service__block__two p_relative h-100">
                            <div className="service__image" style={{ backgroundImage: `url(${shape5})` }}>
                                
                            </div>
                            <div className="service__icon">
                                <div className="service__number">
                                    <h1>0{id+1}</h1>
                                </div>
                                <i className={item.icon}></i>
                            </div>
                            <div className="service__text">
                                <h4><Link to={item.href} state={{service: item, services: servicesData}} >{item.title}</Link></h4>
                                <p>{item.description}</p>
                            </div>
                            <div className="service__button__two">
                                <Link to={item.href} state={{service: item, services: servicesData}} >Read More</Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section> */}
            <div className="service__contact see__pad p_relative">
                <div className="auto-container">
                    <div className="service__contact__block">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <div className="service__form__data">
                                    <div className="form__title">
                                        <div className="title__data">
                                            <div className="sub__title">
                                                <h4>Contact Us</h4>
                                            </div>
                                            <div className="title">
                                                <h2>Send message</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-inner">
                                        <form onSubmit={handleSubmit} method="post" action="contact.php" className="default-form">
                                            <div className="row clearfix">
                                                <div className="col-xl-6 form-group">
                                                    <input type="name" name="name" placeholder="Your Name *" required="" />
                                                </div>
                                                <div className="col-xl-6 col-lg-12 form-group">
                                                    <input type="email" name="email" placeholder="Your Email *" required="" />
                                                </div>
                                                <div className="col-xl-6 col-lg-12 form-group">
                                                    <input type="text" name="subject" placeholder="Your Subject " required="" />
                                                </div>
                                                <div className="col-xl-6 col-lg-12 form-group">
                                                    <input type="text" name="phone" placeholder="Your Phone " required="" />
                                                </div>
                                                <div className="ccol-xl-6 col-lg-12 form-group">
                                                    <textarea name="message" placeholder="Message"></textarea>
                                                </div>
                                                <div className="col-xl-12 form-group message-btn btn-box">
                                                    <button className="theme-btn theme-btn-one" type="submit" name="submit-form">Send your Message</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 p_relative">
                                <div className="service__contact__img">
                                    <figure>
                                        <img src={two} alt=" /" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterOne></FooterOne>
        </>
    );
};

export default Services;
